import { Box, Button, Grid, Typography } from "@mui/material";
import GlobalInformationCard from "../../components/useCase/GlobalInformationsCard";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openDeleteModal,
  closeDeleteModal,
} from "../../redux/actions/useCaseActionCreators";
import {
  getFormattedDay,
  getFormattedMonth,
  getFormattedYear,
} from "../../utils/utils";
import DeleteDialog from "../../components/useCase/DeleteDialog";
import { useTranslation } from "react-i18next";
import { useParams, useLocation, useHistory } from "react-router-dom";
import AddModal from "./AddModal";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { fetchAllUseCase } from "../../redux/actions/useCaseActionCreators";
import {
  fetchQuizById,
  requestEditQuizz,
  requestAddQuizz,
} from "../../redux/actions/quizzesActionCreators";
import Table from "./UseCasesTable";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import UseCaseModal from "./UseCaseModal";
import { useMediaQuery } from "@mui/material";
import { translate } from "../../utils/utils";
import { RouterPrompt } from "../../components/shared/RouterPrompt";

const MakeQuizz = () => {
  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;
  const accountId = JSON.parse(storedUser)?.account_id;
  const orgaId = localStorage.getItem("orgaId");

  const [selectedUseCases, setSelectedUseCases] = useState([]);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openUseCaseModal, setOpenUseCaseModal] = useState(false);
  const [useCases, setUseCases] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [newPath, setNewPath] = useState("");
  const isMobile = useMediaQuery("(max-width:1400px)");
  const location = useLocation();
  const newVersion = location.search.includes("newversion");
  const isUpdate = location.search.includes("update");
  const { t } = useTranslation();
  const quizzData = useSelector((state) => state.quizzes.selected);
  const infiniteUseCases = useSelector(
    (state) => state.useCase.infiniteUseCases
  );
  const totalPages = useSelector((state) => state.useCase.totalPages);

  const isAuth = useSelector((state) => state.user.isAuth);
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const lang = localStorage.getItem("i18nextLng")

  useEffect(() => {
    setUseCases(quizzData?.usecases);
  }, [quizzData]);

  const handleUseCases = (cases) => {
    setUseCases(cases);
  };

  const handleDisabled = () => {
    setDisabled(false);
  };

  const handleLeave = async() => {
    await setDisabled(true)
    await setShowPrompt(false);
    history.push("/quizzes");
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setPage(1);
  };

  const handlePage = (pageNum) => {
    setPage(pageNum);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchAllUseCase(page, searchText, "all", "all", true));
    }, 500);
    return () => clearTimeout(timer);
  }, [dispatch, page, searchText]);

  useEffect(() => {
    const unblock = history.block((location) => {
      if (!disabled) {
        setShowPrompt(true);
        setNewPath(location.pathname);
        return false;
      }
      return true;
    });

    const handleBeforeUnload = (event) => {
      if (!disabled) {
        setShowPrompt(true);
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      unblock();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [history, disabled]);

  useEffect(() => {
    if (accountType === "enterprise") {
      dispatch(fetchQuizById(isAuth, params.quizzId, orgaId, accountType));
    } else {
      dispatch(fetchQuizById(isAuth, params.quizzId, orgaId, accountType));
    }
  }, [dispatch, params.quizzId]);

  const handleDeleteQuestion = (id) => {
    dispatch(openDeleteModal());
    setSelectedQuestionId(id);
  };
  const handleCheckUseCase = (row) => {
    if (selectedUseCases.some((item) => item.id === row.id)) {
      setSelectedUseCases([...selectedUseCases.filter((x) => x.id !== row.id)]);
    } else {
      setSelectedUseCases([...selectedUseCases, row]);
    }
  };

  const handleNewVersion = () => {
    dispatch(
      requestAddQuizz(
        {
          title: quizzData.title,
          description: quizzData.description,
          usecases: useCases.map((el) => el.id),
          title_fr: quizzData.title_fr,
          description_fr: quizzData.description_fr,
          base_quiz_id: quizzData.base_quiz_id,
          icon_url: quizzData.icon_url,
        },
        history,
        accountType,
        accountId,
        true
      )
    );
    setDisabled(true);
  };

  const handleAddUseCaseToQuizz = () => {
    if (useCases.length > 0) {
      setUseCases(useCases.concat(selectedUseCases));
    } else {
      setUseCases(selectedUseCases);
    }

    setOpenUseCaseModal(false);
    setSelectedUseCases([]);
  };

  const useCaseHead = [
    { align: "right", value: "" },
    { align: "left", value: t("name") },
    { align: "left", value: "source" },
    { align: "center", value: t("threshold") },
    { align: "center", value: "coefficient" },
    { align: "center", value: "Questions " },
  ];

  const head = isMobile
    ? [
        { align: "left", value: t("name") },
        { align: "right", value: "" },
      ]
    : [
        { align: "right", value: "" },
        { align: "left", value: t("name") },
        { align: "left", value: "source" },
        { align: "center", value: t("threshold") },
        { align: "center", value: "coefficient" },
        { align: "center", value: t("level") },
        { align: "left", value: t("related_weakness") },
        { align: "right", value: "" },
      ];

  useEffect(() => {
    let theSame = useCases?.every(
      (obj1, index) => obj1?.id === quizzData?.usecases[index]?.id
    );
    if (
      (quizzData?.usecases?.length === 0 || theSame) &&
      quizzData?.usecases?.length === useCases?.length
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [quizzData, useCases]);

  const handleSaveOrder = () => {
    dispatch(
      requestEditQuizz(
        isAuth,
        {
          usecases: useCases.map((el) => el.id),
        },
        params.quizzId,
        accountId,
        accountType,
        orgaId
      )
    );
  };

  return (
    <>
      {quizzData && (
        <Box
          sx={{
            padding: "0px 20px 50px 20px",
          }}
        >
          {isMobile && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <GlobalInformationCard
                label={t("creator")}
                value={quizzData?.creator || t("unknown")}
              />
              <GlobalInformationCard
                label={t("last_update")}
                value={`${getFormattedDay(
                  quizzData?.last_update
                )} ${getFormattedMonth(
                  quizzData?.last_update
                )} ${getFormattedYear(quizzData?.last_update)}`}
              />
              <GlobalInformationCard
                label={t("difficulty")}
                value={t(quizzData?.difficulty_level)}
              />
            </div>
          )}
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{
              background:
                "linear-gradient(180deg, white 0%, white 90%, transparent 100%)",

              top: "0px",
              zIndex: "100",
              padding: "20px 0px",
            }}
          >
            <Grid item xs={11}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="title">
                    {quizzData[translate("title")] || t("not_specified")}
                  </Typography>
                  {!newVersion && (
                    <Button
                      fullwidth
                      variant="outlined"
                      color="button"
                      size="small"
                      sx={{ marginLeft: "10px" }}
                      onClick={(e) => {
                        setOpenEditModal(true);
                      }}
                    >
                      <ModeEditOutlineOutlinedIcon />
                    </Button>
                  )}
                </div>
                {!isMobile && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <GlobalInformationCard
                      label={t("creator")}
                      value={quizzData?.creator || t("unknown")}
                    />
                    <GlobalInformationCard
                      label={t("last_update")}
                      value={`${getFormattedDay(
                        quizzData?.last_update
                      )} ${getFormattedMonth(
                        quizzData?.last_update
                      )} ${getFormattedYear(quizzData?.last_update)}`}
                    />
                    <GlobalInformationCard
                      label={t("difficulty")}
                      value={t(quizzData?.difficulty_level)}
                    />
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={11}>
              <p>
                <span style={{ fontWeight: 600 }}>Version: </span>
                {quizzData.version}
              </p>

              <p>
                <span style={{ fontWeight: 600 }}>Description: </span>
                {quizzData[translate("description")] || t("not_specified")}
              </p>
            </Grid>
            <Grid item xs={11}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="accordion1">
                  {t("related_usecase")}
                </Typography>

                {!isMobile && (
                  <div>
                    <Button
                      variant="contained"
                      color="button"
                      sx={{ height: "50px", mr: "20px" }}
                      onClick={() => {
                        setOpenUseCaseModal(true);
                      }}
                    >
                      <AddOutlinedIcon />
                      {isMobile ? t("usecase") : t("add_usecase")}
                    </Button>
                    {newVersion ? (
                      <Button
                        variant="contained"
                        color="button"
                        sx={{ height: "50px", mr: "20px", fontSize: "13px" }}
                        onClick={handleNewVersion}
                        disabled={disabled}
                      >
                        {t("confirm_new_version")}
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="button"
                        sx={{ height: "50px", mr: "20px" }}
                        onClick={handleSaveOrder}
                        disabled={disabled}
                      >
                        {t("confirm")}
                      </Button>
                    )}

                    {/* )} */}
                  </div>
                )}
              </div>
              <span className="error-message-autocomplete">{t("reorder")}</span>
              {isMobile && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="button"
                    sx={{ height: "40px", fontSize: "13px" }}
                    onClick={() => {
                      setOpenUseCaseModal(true);
                    }}
                  >
                    <AddOutlinedIcon />
                    {isMobile ? t("usecase") : t("add_usecase")}
                  </Button>
                  {newVersion ? (
                    <Button
                      variant="contained"
                      color="button"
                      sx={{ height: "40px", fontSize: "13px" }}
                      onClick={handleNewVersion}
                      disabled={disabled}
                    >
                      {t("new_version")}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="button"
                      sx={{ height: "40px", fontSize: "13px" }}
                      onClick={handleSaveOrder}
                      disabled={disabled}
                    >
                      {t("confirm")}
                    </Button>
                  )}

                  {/* )} */}
                </div>
              )}
            </Grid>

            <Grid item xs={11}>
              {/* {!isMobile ? ( */}
              <Table
                data={useCases}
                quizzId={quizzData.id}
                disabled
                head={head}
                quizz="quizz"
                handleUseCases={handleUseCases}
                newVersion={newVersion}
                isMobile={isMobile}
              />
              {/* ) : (
                <AccordionMakeQuiz
                  data={useCases}
                  quizzId={quizzData.id}
                  disabled
                  head={head}
                  quizz="quizz"
                  handleUseCases={handleUseCases}
                  newVersion={newVersion}
                />
              )} */}
            </Grid>
          </Grid>
          <DeleteDialog
            description={t("would_you_like")}
            open={quizzData.openDeleteModal}
            handleClose={() => dispatch(closeDeleteModal())}
            title={t("are_you_sure")}
            buttonLabel={t("remove_question")}
          />
          <AddModal
            title={newVersion ? t("make_new_version") : "Update Quizz"}
            quizzId={quizzData.id}
            open={openEditModal}
            handleClose={() => setOpenEditModal(false)}
            initialValues={{
              title: (lang==="fr"? quizzData.title_fr :quizzData.title),
              description: (lang==="fr"? quizzData.description: quizzData.description),
              category:(lang==="fr"? quizzData.category_fr :quizzData.category),
            }}
            isUpdate
            newVersion={newVersion}
            iconUrl={quizzData?.icon_url}
          />

          {/* {infiniteUseCases.length && ( */}
          <UseCaseModal
            selectedUseCases={selectedUseCases}
            handleAddUseCaseToQuizz={handleAddUseCaseToQuizz}
            handleCheckUseCase={(row) => handleCheckUseCase(row)}
            handleClose={() => {
              setOpenUseCaseModal(false);
              setSearchText("");
            }}
            open={openUseCaseModal}
            data={infiniteUseCases.filter(
              (item) =>
                !useCases?.map((x) => x.id).includes(item.id) &&
                item?.questions?.length > 0
            )}
            head={useCaseHead}
            handleSearch={handleSearch}
            handlePage={handlePage}
            page={page}
            totalPages={totalPages}
            searchText={searchText}
          ></UseCaseModal>
          {/* )} */}
          <RouterPrompt
            setShowPrompt={(state) => setShowPrompt(state)}
            when={showPrompt}
            handleLeave={handleLeave}
            newVersion={newVersion}
            isUpdate={isUpdate}
            handleNewVersion={handleNewVersion}
            handleSaveOrder={handleSaveOrder}
            newPath={newPath}
            text={t(
              "there_are_unsaved_changes_are_you_sure_want_to_leave_this_page"
            )}
            title={t("leave_this_page")}
            handleDisabled={handleDisabled}
            disabled={disabled}
          />
        </Box>
      )}
    </>
  );
};

export default MakeQuizz;
